import { cn } from '@/lib/utils.js'

export function TypographyH1({ className, ...props }) {
    return (
        <h1 className={`scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl ${className}`} {...props} />
    )
}

export function TypographyH2({ className, ...props }) {
    return (
        <h2 className={`scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0 ${className}`} {...props} />
    )
}

export function TypographyH3({ className, ...props }) {
    return (
        <h3 className={cn("scroll-m-20 text-2xl tracking-tight", className)} {...props} />
    )
}

export function TypographyH4({ className, ...props }) {
    return (
        <h4 className={`text-lg leading-none tracking-tight ${className}`} {...props} />
    )
}

export function TypographyP({ className, ...props }) {
    return (
        // <p className={`leading-7 font-light [&:not(:first-child)]:mt-6 ${className}`} {...props} />
        <p className={`leading-6 font-light ${className}`} {...props} />
    )
}

export function TypographyBlockquote({ className, ...props }) {
    return (
        <blockquote className={`mt-6 border-l-2 pl-6 italic ${className}`} {...props} />
    )
}

export function TypographyInlineHighlight({ className, ...props }) {
    return (
        <code className={`relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold ${className}`} {...props} />
    )
}

export function TypographyLarge({ className, ...props }) {
    return (
        <div className={`text-lg ${className}`} {...props} />
    )
}

export function TypographySmall({ className, ...props }) {
    return (
        <p className={`text-sm ${className}`} {...props} />
    )
}

export function TypographySmallMuted({ className, ...props }) {
    return (
        <p className={`text-sm text-muted-foreground ${className}`} {...props} />
    )
}

export function TypographyXSmall({ className, ...props }) {
    return (
        <p className={`text-xsm ${className}`} {...props} />
    )
}

export function TypographyXSmallMuted({ className, ...props }) {
    return (
        <p className={`text-xsm text-muted-foreground leading-2 ${className}`} {...props} />
    )
}

